import { z } from 'zod';

const requiredString = z.string().trim().min(1);
const optionalString = requiredString.optional();

export const publicEnvShape = {
  NEXT_PUBLIC_AMPLITUDE_API_KEY: optionalString,
  NEXT_PUBLIC_AMPLITUDE_API_KEY_MIGRATION: optionalString,
  NEXT_PUBLIC_AMPLITUDE_MODE: z.literal('migration').optional(),
  NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY: requiredString,
  NEXT_PUBLIC_PRIVY_CLIENT_ID: requiredString,
  NEXT_PUBLIC_PRIVY_ID: requiredString,
  NEXT_PUBLIC_REDDIT_PIXEL_ID: requiredString,
  NEXT_PUBLIC_SENTRY_DSN: z.string().trim().url().optional(),
  NEXT_PUBLIC_TRADE_SURPLUS_RECIPIENT_ADDRESS: optionalString,
  NEXT_PUBLIC_VERCEL_ENV: z.enum(['development', 'preview', 'production']).optional(),
  NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL: optionalString,
  NEXT_PUBLIC_VERCEL_URL: optionalString,
  NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID: requiredString,
};

type PublicEnvShape = z.infer<z.ZodObject<typeof publicEnvShape>>;

export const validatePublicEnv = (environment: PublicEnvShape, context: z.RefinementCtx) => {
  if (environment.NEXT_PUBLIC_VERCEL_ENV === 'preview' && !environment.NEXT_PUBLIC_VERCEL_URL) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'A Vercel URL is required in preview environments',
      path: ['NEXT_PUBLIC_VERCEL_URL'],
    });
  }
};

export const publicEnvSchema = z.object(publicEnvShape).superRefine(validatePublicEnv);
